import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import PaymentFailedDialog from "./components/PaymentFailedDialog";
import {Colors, Text} from "@bounce/shared/ui";

type SuccessPayment = {success: true; error_message: null};
type FailedPayment = {success: false; error_message: string};

export type IResponseData = SuccessPayment | FailedPayment;

interface PaymentContextProps {
  buttonTouched: boolean;
  setButtonTouched: (value: boolean) => void;
  isLoading?: boolean;
  showOneCentLabel?: boolean;
  showLargeSplitLabel?: boolean;
  disableButton?: boolean;
  disableACHAccountOwnerPrePopulation?: boolean;
}
export const PaymentContext = React.createContext<PaymentContextProps>(undefined!);

const openPaymentFailedDialog = (error: string) => {
  NiceModal.show(PaymentFailedDialog, {error});
};

export const formatInput = (inputValue: any) => {
  const inputValueWithoutDashes = inputValue.replace(/-/g, "");
  const formattedValue = inputValueWithoutDashes.replace(/(.{4})/g, "$1-");
  return formattedValue.replace(/-$/, "");
};

const getPlanType = (isSinglePayment: boolean, isHardship: boolean) => {
  if (isSinglePayment) {
    return "one_time_payment";
  }
  if (isHardship) {
    return "hardship_plan";
  }
  return "payment_plan";
};

const getAmountValidationMessage = (amount: number, totalBalance: number) => {
  if (amount < 0) return "Invalid amount";
  if (amount > totalBalance) return "Insert a lower amount";
  return "Insert a higher amount";
};

const getAmountValidationHelperText = ({
  isValid,
  amount,
  totalBalance,
}: {
  isValid: boolean;
  amount?: number;
  totalBalance: number;
}) => {
  if (amount === 0 || isValid) {
    return;
  }
  if (!isValid && amount && amount !== 0) {
    return (
      <Text size={12} variant={"interDisplay400"} sx={{color: Colors.red._900}}>
        {getAmountValidationMessage(amount, totalBalance)}
      </Text>
    );
  }
};

export {openPaymentFailedDialog, getPlanType, getAmountValidationHelperText};
